const h = "http://62.72.35.120:80/";

const Users = 'users/';
const Aufa = 'aufa/';
const AdminProject = 'admin-grop-csv/';
const Docket = 'docket/';

function updateLocalStorage(key, newValue) {
    sessionStorage.removeItem('token');
    const oldValue = localStorage.getItem(key);
    const storageEvent = new StorageEvent('storage', {
        key: key,
        oldValue: oldValue,
        newValue: newValue, // שינוי זה
        url: window.location.href,
        storageArea: localStorage
    });

    window.dispatchEvent(storageEvent);
}


export function PostHttp(host, data, token = true) {
    return new Promise((resolve, reject) => {
        let http = new XMLHttpRequest();

        http.onload = function () {
            if (http.status === 200) {
                const responseText = JSON.parse(this.responseText);

                if (responseText === 'no-token') {
                    updateLocalStorage('change', 'yes');
                } else {
                    resolve(responseText);
                }

            } else {
                resolve(http.status);
            }
        }

        http.onerror = function () {
            reject(this.responseText);
        }

        http.open("POST", h + host);

        http.setRequestHeader("Content-Type", "application/json");
        if (token) {
            const tokenSend = sessionStorage.getItem('token');
            if (tokenSend) {
                http.setRequestHeader("Authorization", tokenSend);
            } else {
                updateLocalStorage('change', 'yes');
            }
        }
        http.send(JSON.stringify(data));
    })
}


export function GetHttp(host, data, token = true) {
    return new Promise((resolve, reject) => {
        let http = new XMLHttpRequest();
        http.onload = function () {
            if (http.status === 200) {
                let c = JSON.parse(this.responseText);
                if (c === 'no-token') {
                    updateLocalStorage('change', 'yes');
                }
                resolve(c);
            } else {
                resolve(http.status);
            }
        }
        http.onerror = () => {
            console.log('error in fetch');
            reject('error');
        }

        http.open("GET", h + host);
        if (token) {
            const tokenSend = sessionStorage.getItem('token');
            if (tokenSend) {
                http.setRequestHeader("Authorization", tokenSend);
            } else {
                updateLocalStorage('change', 'yes');
            }
        }
        http.send();
    })
}

export function PostDesktop(host, data) {
    return PostHttp('desktopDocket/' + host, data);
}

export function fetchGetDocket(host) {
    return GetHttp(Docket + host);
}

export function fetchPostDocket(host, data) {
    return PostHttp(Docket + host, data);
}

export function fetchPostUsers(host, data) {
    return PostHttp(Users + host, data);
}

export function fetchPostAufa(host, data) {
    return PostHttp(Aufa + host, data);
}

export function fetchGetAufa(host) {
    console.log("fetcjGetAufa", host);
    return GetHttp(Aufa + host);
}

export function fetchGetFilter(host) {
    console.log("fetchGetFilter", host);
    return GetHttp('filter' + host);
}


export function fetchGetAdminProject(host) {
    return GetHttp(AdminProject + host);
}

export function fetchPost(data, host) {
    return PostHttp(h + host, data)
}

export function getWorkerName(data) {
    return PostHttp(Docket + 'worker-name', data);
}

export function SendCsvFileAdminGrop(file, fileName) {
    return new Promise((resolve, reject) => {
        let http = new XMLHttpRequest();
        http.onload = function () {
            resolve(JSON.parse(this.responseText));
        }
        http.onerror = function () {
            reject(this.responseText);
        }
        http.open("POST", `${h}admin-grop-csv/${fileName}`);

        const tokenSend = sessionStorage.getItem('token');
        if (tokenSend) {
            http.setRequestHeader("Authorization", tokenSend);
        } else {
            updateLocalStorage('change', 'yes');
        }

        let fromData = new FormData();
        fromData.append('file', file);
        http.send(fromData);
    })
}

export function GetCsvFileAdminGrop(file) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${h}admin-grop-csv/${file}`, true);
    xhr.onload = function () {
        if (xhr.status === 200) {
            const blob = xhr.response;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${file}`;
            a.target = '_blank';
            a.click();
        }
    }

    const tokenSend = sessionStorage.getItem('token');
    if (tokenSend) {
        xhr.setRequestHeader("Authorization", tokenSend);
    } else {
        updateLocalStorage('change', 'yes');
    }
    xhr.responseType = 'blob';
    xhr.send();
}

export function generateReceipt(host, data) {
    return new Promise((resolve, reject) => {
        let http = new XMLHttpRequest();

        http.onload = function () {
            if (http.status === 200) {
                resolve(http.response); // Resolve with the Blob response
            } else {
                reject(http.status);
            }
        }

        http.onerror = function () {
            reject(this.responseText);
        }

        http.open("POST", h + Docket + host);
        http.setRequestHeader("Content-Type", "application/json");

        const tokenSend = sessionStorage.getItem('token');
        if (tokenSend) {
            http.setRequestHeader("Authorization", tokenSend);
        } else {
            updateLocalStorage('change', 'yes');
        }

        http.responseType = 'blob'; // Expect a Blob (binary) response
        http.send(JSON.stringify(data));

    });
}

export function generateInvoice(host, data) {
    console.log("generateInvoice", data)
    return new Promise((resolve, reject) => {
        let http = new XMLHttpRequest();

        http.onload = function () {
            if (http.status === 200) {
                resolve(http.response); // Resolve with the Blob response
            } else {
                reject(http.status);
            }
        }

        http.onerror = function () {
            reject(this.responseText);
        }

        http.open("POST", h + Docket + host);
        http.setRequestHeader("Content-Type", "application/json");

        const tokenSend = sessionStorage.getItem('token');
        if (tokenSend) {
            http.setRequestHeader("Authorization", tokenSend);
        } else {
            updateLocalStorage('change', 'yes');
        }

        http.responseType = 'blob'; //  a BExpectlob (binary) response
        http.send(JSON.stringify(data));

    });
}

// export function generateTickets(host, data) {
//     console.log("generateTickets", data)
//     return new Promise((resolve, reject) => {
//         let http = new XMLHttpRequest();

//         http.onload = function () {
//             if (http.status === 200) {
//                 resolve(http.response); // Resolve with the Blob response
//             } else {
//                 reject(http.status);
//             }
//         }

//         http.onerror = function () {
//             reject(this.responseText);
//         }

//         http.open("POST", h + Docket + host);
//         http.setRequestHeader("Content-Type", "application/json");

//         const tokenSend = sessionStorage.getItem('token');
//         if (tokenSend) {
//             http.setRequestHeader("Authorization", tokenSend);
//         } else {
//             updateLocalStorage('change', 'yes');
//         }

//         http.responseType = 'blob'; //  a BExpectlob (binary) response
//         http.send(JSON.stringify(data));

//     });
// }

// export function generateTickets(host, data) {
//     console.log("generateTickets", data);
//     return new Promise((resolve, reject) => {
//         let http = new XMLHttpRequest();

//         http.onload = function () {
//             const contentType = http.getResponseHeader("Content-Type");

//             if (http.status === 200 && contentType.includes('application/zip')) {
//                 resolve(http.response); // Success with a Blob response
//             } else if (contentType.includes('application/json')) {
//                 // If the server returned JSON, parse it and reject as an error
//                 const errorResponse = JSON.parse(http.responseText);
//                 reject(errorResponse);
//             } else {
//                 reject({ status: http.status, message: "Unknown error occurred" });
//             }
//         };

//         http.onerror = function () {
//             reject({ status: http.status, message: this.responseText });
//         };

//         http.open("POST", h + Docket + host);
//         http.setRequestHeader("Content-Type", "application/json");

//         const tokenSend = sessionStorage.getItem('token');
//         if (tokenSend) {
//             http.setRequestHeader("Authorization", tokenSend);
//         } else {
//             updateLocalStorage('change', 'yes');
//         }

//         http.responseType = 'blob'; // Expect a Blob response (for the zip file)
//         http.send(JSON.stringify(data));
//     });
// }

export function generateTicketsDownload(host, data) {
    console.log("generateTicketsDownload", data);
    return new Promise((resolve, reject) => {
        let http = new XMLHttpRequest();

        http.onload = function () {
            const contentType = http.getResponseHeader("Content-Type");
            console.log("http", http);
            if (http.status === 200 && contentType.includes('application/zip')) {
                resolve(http.response); // Success with a Blob response
            } else if (contentType.includes('application/json')) {
                // If the server returned JSON, parse it and reject as an error
                // const errorResponse = JSON.parse(http.responseText);
                reject(http.status);
            } else {
                reject({ status: http.status, message: "Unknown error occurred" });
            }
        };

        http.onerror = function () {
            reject({ status: http.status, message: "error" });
        };

        http.open("POST", h + Docket + host);
        http.setRequestHeader("Content-Type", "application/json");

        const tokenSend = sessionStorage.getItem('token');
        if (tokenSend) {
            http.setRequestHeader("Authorization", tokenSend);
        } else {
            updateLocalStorage('change', 'yes');
        }

        // Set responseType to 'blob' only when expecting a file download, otherwise default
        http.responseType = 'blob'; 
        http.send(JSON.stringify(data));
    });
}

export function generateTicketsEmail(host, data) {
    console.log("generateTicketsEmail", data);
    return new Promise((resolve, reject) => {
        let http = new XMLHttpRequest();

        http.onload = function () {
            const contentType = http.getResponseHeader("Content-Type");
            console.log("http", http);
            if (http.status === 200) {
                // If the response is JSON, resolve with parsed JSON
                if (contentType.includes('application/json')) {
                    const jsonResponse = JSON.parse(http.responseText);
                    resolve(jsonResponse); // Resolve with the JSON response
                } else {
                    reject({ status: http.status, message: "Unexpected response type" });
                }
            } else {
                // Reject on non-200 status
                reject({ status: http.status, message: "Error: " + http.status });
            }
        };

        http.onerror = function () {
            reject({ status: http.status, message: "error" });
        };

        http.open("POST", h + Docket + host);
        http.setRequestHeader("Content-Type", "application/json");

        const tokenSend = sessionStorage.getItem('token');
        if (tokenSend) {
            http.setRequestHeader("Authorization", tokenSend);
        } else {
            updateLocalStorage('change', 'yes');
        }

        // Set responseType to 'blob' only when expecting a file download, otherwise default
        // Set responseType to 'text' for emails since we expect JSON
        http.responseType = 'text'; 
        http.send(JSON.stringify(data));
    });
}


